import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M9.557 7.243a.46.46 0 0 0-.457-.252C9.023 7 8.951 7 8.877 7A4 4 0 0 1 5.546.781a.5.5 0 0 0 .018-.525A.48.48 0 0 0 5.1 0a5 5 0 1 0 4.439 7.767.5.5 0 0 0 .018-.524"
    }, null, -1)
  ]));
}
const interfaceWeatherMoon = { render };
export {
  interfaceWeatherMoon as default,
  render
};
//# sourceMappingURL=interface-weather-moon.svg.js.map
